export enum EFeatures {
  BinahObservations = 'BinahObservations',
}
